import { render, staticRenderFns } from "./GameMessage.vue?vue&type=template&id=74d81fe3&scoped=true"
import script from "./GameMessage.vue?vue&type=script&lang=js"
export * from "./GameMessage.vue?vue&type=script&lang=js"
import style0 from "./GameMessage.vue?vue&type=style&index=0&id=74d81fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d81fe3",
  null
  
)

export default component.exports